// extracted by mini-css-extract-plugin
export default {"loader":"mimic___styles_loader__+SSK4"};